import { AnalyticsEvent } from 'utils/analytics/event'

export const silent_gl_my_account_change_plan_click = new AnalyticsEvent({
  onFire(ctx) {
    ctx.fireEvent('silent_gl_my_account_change_plan_click')
  },
})
